module.exports = __webpack_public_path__ + "img/t1-name.aff409a2.png";